import { FC } from 'react'

import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import IconSuccessfully from 'src/Assets/Svg/successfully.svg?react'
import { device, variables } from 'src/Styled/variables'
import { GreyTextButton } from 'src/Components/Buttons/GreyTextButton'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import {
  clearSubscriptionFromLocation,
  getSubscriptionFromLocation,
} from 'src/Redux/subscription-process/subscriptionFromLocation'
import { FullScreenModal } from 'src/Components/FullScreenModal'

const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
`
const Wrapper = styled.div`
  display: flex;
  padding: 40px 16px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  @media ${device.mobileMin} {
    width: 560px;
  }
`

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`

const Title = styled.div`
  color: ${({ theme }) => theme.color.slateGrey};
  text-align: center;
  font-size: 18px;
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const Description = styled.div`
  color: ${({ theme }) => theme.color.slateGrey};
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

const StyledButton = styled(GreyTextButton)`
  width: fit-content;
  padding: 0 40px;
`

export const SuccessPaymentSubscription: FC = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const fromLocation = useAppSelector(getSubscriptionFromLocation)
  const handleClose = (): void => {
    if (fromLocation) {
      navigate(fromLocation)
      dispatch(clearSubscriptionFromLocation())
      return
    }
    navigate('/')
  }

  return (
    <FullScreenModal open>
      <Container>
        <Wrapper>
          <IconSuccessfully />
          <TextWrapper>
            <Title>Thank You for Subscribing!</Title>
            <Description>
              You unlocked great opportunities for promoting your music! Enjoy
              hassle-free campaign launches & exclusive benefits. Easily manage
              your subscription from the balance page.
            </Description>
          </TextWrapper>
          <StyledButton onClick={handleClose}>Got it!</StyledButton>
        </Wrapper>
      </Container>
    </FullScreenModal>
  )
}
